export default function getResource(label) {
    const resources = { reviews: 'reviews' };
    return resources[label];
}
